export const mapIcon = (theme: string | { theme?: string }): string => {
  const raw = typeof theme === 'string' ? theme : (theme?.theme || '');

  const slug = raw
    .toLowerCase()
    .normalize('NFD').replace(/\p{Diacritic}+/gu, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_{2,}/g, '_');

  if (slug === 'dagstructuur') return 'clock';

  return slug || 'clock';
};
